export default "__VITE_ASSET__23ddb173__"